import { CefApplianceCastStatus, CefApplianceCastStatusChange } from '../types'
import fb from '../../../firebase'
import { CollectionNames } from '@/modules/database/utils'

export const addCastStatusChange = (castId: string,
                                    params: Omit<CefApplianceCastStatusChange, 'timestamp'>) => {
  try {
    const statusChange: CefApplianceCastStatusChange = {
      status: params.status,
      timestamp: new Date(),
      cefApplianceId: params.cefApplianceId,
      teamId: params.teamId
    }
    const statsData: CefApplianceCastStatus = {
      statusChanges: fb.arrayUnionField(statusChange)
    }

    fb.db.collection(CollectionNames.CEFAPPLIANCE_CAST_STATS).doc(castId).set(statsData, { merge: true })
         .catch((error) => { console.error('cefappliance_caststats', error) })
  } catch (error) {
    console.error('cefappliance_caststats', error)
  }
}
